import { render, staticRenderFns } from "./UnitList.vue?vue&type=template&id=605cd7d0&scoped=true"
import script from "./UnitList.vue?vue&type=script&lang=js"
export * from "./UnitList.vue?vue&type=script&lang=js"
import style0 from "./UnitList.vue?vue&type=style&index=0&id=605cd7d0&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "605cd7d0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JSH_ERP\\JSH_ERP\\mgerpweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('605cd7d0')) {
      api.createRecord('605cd7d0', component.options)
    } else {
      api.reload('605cd7d0', component.options)
    }
    module.hot.accept("./UnitList.vue?vue&type=template&id=605cd7d0&scoped=true", function () {
      api.rerender('605cd7d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/UnitList.vue"
export default component.exports